import React from "react";
import Stack from "@mui/material/Stack";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import AuthUserDropdown from "../../../../shared/widgets/AuthUserDropdown";
import NotificationsDropdown from "../../../../shared/NotificationsDropdown";
import MessagesDropdown from "../../../../shared/MessagesDropdown";
import SearchGlobal from "../../../../shared/SearchGlobal";
import {
  Slide,
  useMediaQuery,
  Box,
  Collapse,
  Alert,
  Button,
  Popover,
  Typography,
  Divider,
} from "@mui/material";
import Div from "@jumbo/shared/Div";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import JumboIconButton from "@jumbo/components/JumboIconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Logo from "../../../../shared/Logo";
import { SIDEBAR_STYLES, SIDEBAR_VARIANTS } from "@jumbo/utils/constants";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import SettingsIcon from "@mui/icons-material/Settings";
import { useLocation } from "react-router-dom";
import DateFilters from "./DateFilters";
import { canViewPrepaidBalance, isMobile, numberFormat } from "app/utils/utils";
import { useSelector } from "react-redux";
import { showHideUserTimezoneModal } from "app/store/slice/common-slice";
import { dispatch } from "app/store/store";
import { LightTooltip } from "app/Common/Elements";
import { Edit } from "@mui/icons-material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import IconButton from "@mui/material/IconButton";
const Header = () => {
  const [open, setOpen] = React.useState(true);
  const [balanceAnchorEl, setBalanceAnchorEl] = React.useState(null);
  const ismobile = isMobile();
  const location = useLocation();
  const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
  const [dropdownSearchVisibility, setDropdownSearchVisibility] =
    React.useState(false);
  const { headerTheme } = useJumboHeaderTheme();

  const {
    userTimezone,
    openUserTimezoneModal,
    prepaidAccountDetails,
    authUserData,
  } = useSelector((state) => state.CommonReducer);
  const canShowPrepaidBalance = canViewPrepaidBalance(authUserData);
  const prepaidAccounts = prepaidAccountDetails?.prepaidAccounts || [];
  const balancePopoverOpen = Boolean(balanceAnchorEl);

  const handleOpenBalancePopover = (event) => {
    setBalanceAnchorEl(event.currentTarget);
  };

  const handleCloseBalancePopover = () => {
    setBalanceAnchorEl(null);
  };

  const showDropdownSearch = useMediaQuery("(max-width:575px)");
  let showTableSearch = false;
  const locationArr = location.pathname.split("/");
  const screenName = locationArr[locationArr.length - 1];
  let searchPlaceHolder = "Search anything";
  // if (screenName == "managepublishers" || screenName == "managecompanies") {
  //   showTableSearch = true;
  // }
  if (screenName == "managepublishers") {
    searchPlaceHolder = "Search Publishers";
    showTableSearch = true;
  } else if (screenName == "managecompanies") {
    searchPlaceHolder = "Search Organizations";
    showTableSearch = true;
  } else if (screenName == "manageaccounts") {
    searchPlaceHolder = "Search Accounts";
    showTableSearch = true;
  } else if (screenName == "manageusers") {
    searchPlaceHolder = "Search Users";
    showTableSearch = true;
  } else if (screenName == "manageroles") {
    searchPlaceHolder = "Search Roles";
    showTableSearch = true;
  } else if (screenName == "manageadvertisers") {
    searchPlaceHolder = "Search Advertisers";
    showTableSearch = true;
  } else if (screenName == "campaigns") {
    searchPlaceHolder = "Search Campaigns";
    showTableSearch = true;
  } else if (screenName == "managethemes") {
    searchPlaceHolder = "Search Themes";
    showTableSearch = true;
  } else if (screenName == "supplyanalysis") {
    searchPlaceHolder = "Search Supply Analysis";
    showTableSearch = true;
  } else if (screenName == "segments") {
    searchPlaceHolder = "Search Audience Segments";
    showTableSearch = true;
  } else if (screenName == "supplydeals") {
    searchPlaceHolder = "Search Supply Deals";
    showTableSearch = true;
  } else if (screenName == "targetinggroups") {
    searchPlaceHolder = "Search Targeting Groups";
    showTableSearch = true;
  } else if (screenName == "managedemandpartners") {
    searchPlaceHolder = "Search Demand Partners";
    showTableSearch = true;
  } else if (screenName == "manageprivatemarketplace") {
    searchPlaceHolder = "Search Private Market Place";
    showTableSearch = true;
  }

  /***Toggle Button JS*** */
  // const [alignment, setAlignment] = React.useState("day");

  // const handleChange = (event, newAlignment) => {
  //   setAlignment(newAlignment);
  // };

  return (
    <React.Fragment>
      {(sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER ||
        sidebarOptions.variant === SIDEBAR_VARIANTS.TEMPORARY ||
        (sidebarOptions.variant === SIDEBAR_VARIANTS.PERSISTENT &&
          !sidebarOptions.open)) && (
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          sx={{
            ml:
              sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER
                ? -2
                : 0,
            mr: 3,
          }}
          onClick={() => setSidebarOptions({ open: !sidebarOptions.open })}
        >
          {sidebarOptions?.open ? <MenuOpenIcon /> : <MenuIcon />}
        </IconButton>
      )}
      {sidebarOptions?.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER && (
        <Logo sx={{ mr: 3 }} mode={headerTheme.type ?? "light"} />
      )}

      {authUserData?.user_assoc_profiles?.includes("advertiser") &&
        authUserData?.is_sys_admin != 1 &&
        authUserData?.user_account_suspended == 1 &&
        (prepaidAccountDetails?.hasSinglePrepaidAcc ||
          authUserData?.user_all_accounts_prepaid == 1) && (
          <Box sx={{ width: "100%", position: "absolute", left: 0, zIndex: 6 }}>
            <Collapse in={open}>
              <Alert
                severity="error"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                sx={{ mb: 2 }}
              >
                <strong>Alert!</strong> Your ad groups are paused because your
                pre-paid budget has been spent in full. Please contact
                cs@advangelists.com to get your account turned back on.
              </Alert>
            </Collapse>
          </Box>
        )}

      {/* {showDropdownSearch && (
        <Slide in={dropdownSearchVisibility}>
          <Div
            sx={{
              zIndex: 5,
              left: 0,
              right: 0,
              position: "absolute",
              height: "100%",
            }}
          >
            <SearchGlobal
              sx={{
                maxWidth: "none",
                height: "100%",
                display: "flex",

                "& .MuiInputBase-root": {
                  flex: 1,
                  borderRadius: 0,
                  background: (theme) => theme.palette.background.default,
                },
                "& .MuiInputBase-input": {
                  pr: 6,
                },
              }}
            />
            <IconButton
              sx={{
                position: "absolute",
                right: 15,
                top: "50%",
                color: "inherit",
                transform: "translateY(-50%)",
              }}
              onClick={() => setDropdownSearchVisibility(false)}
            >
              <CloseIcon />
            </IconButton>
          </Div>
        </Slide>
      )} */}
      {!showDropdownSearch && showTableSearch && (
        <SearchGlobal
          sx={{
            maxWidth: { xs: 240, md: 320 },
          }}
          plh={searchPlaceHolder}
          screen={screenName}
        />
      )}
      {location.pathname == "/home/dashboard" && !ismobile && <DateFilters />}
      {location.pathname == "/home/reporting" && !ismobile && <DateFilters />}
      {location.pathname == "/bidder/reporting" && !ismobile && <DateFilters />}
      {location.pathname == "/publisher/reporting" && !ismobile && (
        <DateFilters />
      )}
      {location.pathname.includes("/advertiser/reporting") && !ismobile && <DateFilters />}
      {location.pathname.includes("/advertiser/delivery") && !ismobile && <DateFilters />}
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.25}
        sx={{ ml: "auto" }}
      >
        {/* {showDropdownSearch && (
          <JumboIconButton
            elevation={25}
            onClick={() => setDropdownSearchVisibility(true)}
          >
            <SearchIcon fontSize={"small"} />
          </JumboIconButton>
        )} */}
        {/* <MessagesDropdown />*/}
        {prepaidAccountDetails?.hasPrepaidAccounts && canShowPrepaidBalance && (
          <Box sx={{ mr: 2 }}>
            <Stack direction="row" spacing={2}>
              <MonetizationOnIcon />
              <Box
                sx={{
                  "&.MuiBox-root": { marginLeft: "2px", marginTop: "1px" },
                }}
              >
                Account Balance :{" "}
                {prepaidAccountDetails?.prepaidAccountsCount > 1 ? (
                  <Box component="span">
                    <Box
                      component="span"
                      onClick={handleOpenBalancePopover}
                      sx={{
                        color: "#0080F7",
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                    >
                      View
                    </Box>
                  </Box>
                ) : (
                  <Box component="span" sx={{ color: "#999" }}>
                    $ {numberFormat(prepaidAccountDetails?.balance)}
                  </Box>
                )}
              </Box>
            </Stack>
          </Box>
        )}
        <Popover
          open={balancePopoverOpen}
          anchorEl={balanceAnchorEl}
          onClose={handleCloseBalancePopover}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          PaperProps={{
            sx: {
              mt: 1,
              width: 360,
              maxWidth: "calc(100vw - 32px)",
              borderRadius: 2,
              overflow: "hidden",
            },
          }}
        >
          <Box sx={{ px: 2, py: 1.5 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 16 }}>
              Prepaid Account Balances
            </Typography>
            <Typography sx={{ color: "#7d8ca3", fontSize: 12, mt: 0.25 }}>
              {prepaidAccounts.length} prepaid accounts
            </Typography>
          </Box>
          <Divider />
          <Box sx={{ maxHeight: 320, overflowY: "auto", px: 2, py: 1 }}>
            {prepaidAccounts.map((account) => (
              <Box
                key={account.id}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: 2,
                  py: 1,
                }}
              >
                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: 13,
                      lineHeight: 1.3,
                      wordBreak: "break-word",
                    }}
                  >
                    {account.company}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#7d8ca3",
                      fontSize: 12,
                      lineHeight: 1.3,
                      wordBreak: "break-word",
                    }}
                  >
                    {account.name}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: 13,
                    whiteSpace: "nowrap",
                  }}
                >
                  $ {numberFormat(account.balance)}
                </Typography>
              </Box>
            ))}
          </Box>
          <Divider />
          <Box
            sx={{
              px: 2,
              py: 1.25,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#f8fbff",
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: 13 }}>
              Total balance
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
              $ {numberFormat(prepaidAccountDetails?.balance)}
            </Typography>
          </Box>
        </Popover>

        <Box sx={{ mr: 2 }}>{userTimezone}</Box>
        <Box sx={{ cursor: "pointer" }}>
          <LightTooltip title="Edit Timezone">
            <Edit
              onClick={() => dispatch(showHideUserTimezoneModal(true))}
              sx={{ fontSize: "20px", mr: 2, mt: 1 }}
            />
          </LightTooltip>
        </Box>
        <AuthUserDropdown />
      </Stack>
    </React.Fragment>
  );
};

export default Header;
